import type { DEVELOPMENT_AUTH_TENANTS, PRODUCTION_AUTH_TENANTS } from './authTenants';

import { AUTH_TENANTS_BY_ENV } from './authTenants';

export const DEFAULT_AUTH_TENANT_VALUES = ['snowit', 'main', 'default'] as const;
export const DEFAULT_AUTH_TENANT = 'main' as const;

export const AUTH_TENANT_STORAGE_KEY = 'login_auth_tenant';

type ProductionAuthTenant = (typeof PRODUCTION_AUTH_TENANTS)[number];
type DevelopmentAuthTenant = (typeof DEVELOPMENT_AUTH_TENANTS)[number];

type AuthTenantAliasesException = {
  production: {
    [x: string]: ProductionAuthTenant;
  };
  development: {
    [x: string]: DevelopmentAuthTenant;
  };
};

// Aliases that can't be derived by stripping the trailing `-id` from the authTenant.
const EXCEPTIONS: AuthTenantAliasesException = {
  production: {
    discovera: 'viageo-k3md8',
  },
  development: {
    cervino: 'cervino-ski-paradise-78cr4',
    livigno: 'livignonameauth-nd1wu',
    test: 'test-mfa-5if3p',
  },
};

// Removes trailing `-<id>` e.g. 'cervinia-871zh' -> 'cervinia'.
const stripAuthTenantId = (authTenant: string): string => authTenant.replace(/-[a-z0-9]+$/, '');

export const resolveAuthTenant = (input: string | null | undefined): string | undefined => {
  const value = (input ?? '').trim().toLowerCase();
  if (!value || DEFAULT_AUTH_TENANT_VALUES.includes(value as any)) {
    return DEFAULT_AUTH_TENANT;
  }
  const environment = process.env.SNOWIT_ENVIRONMENT;

  const exception = EXCEPTIONS[environment]?.[value];
  if (exception) return exception;

  const authTenants: readonly string[] = AUTH_TENANTS_BY_ENV[environment];
  if (!authTenants) return undefined;

  for (const authTenant of authTenants) {
    if (authTenant.toLowerCase() === value) return authTenant;
    if (stripAuthTenantId(authTenant).toLowerCase() === value) return authTenant;
  }
  return undefined;
};
